import { Component } from '@angular/core';

// Legal review requires the previous footer for now. Set to true to switch the
// whole site (desktop + mobile) to the new PDBe-style footer implementation.
export const USE_NEW_FOOTER = false;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
  standalone: false
})
export class FooterComponent {
  protected readonly useNewFooter = USE_NEW_FOOTER;
}
